import React, { useState } from "react";
import Header from "../components/Header";
import AddBookForm from "../components/AddBookForm";
import BookListSection from "../components/BookListSection";

const HomePage = () => {
  return (
    <>
      <Header />

      {/* main section */}
      <main className="py-12 2xl:px-6">
        <div className="container grid xl:grid-cols-[auto_350px] 2xl:grid-cols-[auto_400px] gap-4 2xl:gap-8">
          <div className="order-2 xl:-order-1">
            <BookListSection />
          </div>
          <AddBookForm />
        </div>
      </main>
    </>
  );
};

export default HomePage;
